/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const de_poi_datasheet__michelin_opinion = /** @type {(inputs: {}) => string} */ () => {
	return `Bewertung des Guide Michelin`
};

const en_poi_datasheet__michelin_opinion = /** @type {(inputs: {}) => string} */ () => {
	return `The Michelin Guide's review`
};

const es_poi_datasheet__michelin_opinion = /** @type {(inputs: {}) => string} */ () => {
	return `La opinión de la Guía Michelin`
};

const fr_poi_datasheet__michelin_opinion = /** @type {(inputs: {}) => string} */ () => {
	return `L'avis du Guide Michelin`
};

const it_poi_datasheet__michelin_opinion = /** @type {(inputs: {}) => string} */ () => {
	return `Il parere della Guida Michelin`
};

const nl_poi_datasheet__michelin_opinion = /** @type {(inputs: {}) => string} */ () => {
	return `De beoordeling van de Michelin Gids`
};

const pt_poi_datasheet__michelin_opinion = /** @type {(inputs: {}) => string} */ () => {
	return `Opinião do Guia Michelin`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const poi_datasheet__michelin_opinion = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.poi_datasheet__michelin_opinion(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("poi_datasheet__michelin_opinion", locale)
	if (locale === "de") return de_poi_datasheet__michelin_opinion(inputs)
	if (locale === "en") return en_poi_datasheet__michelin_opinion(inputs)
	if (locale === "es") return es_poi_datasheet__michelin_opinion(inputs)
	if (locale === "fr") return fr_poi_datasheet__michelin_opinion(inputs)
	if (locale === "it") return it_poi_datasheet__michelin_opinion(inputs)
	if (locale === "nl") return nl_poi_datasheet__michelin_opinion(inputs)
	return pt_poi_datasheet__michelin_opinion(inputs)
};